import React from "react"

type Props = {
  className?: string
}

const TechnologyIcon = ({ className }: Props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3333 14.1663H3.33333C2.87333 14.1663 2.5 13.793 2.5 13.333V6.66634C2.5 6.20634 2.87333 5.83301 3.33333 5.83301H13.3333C13.7933 5.83301 14.1667 6.20634 14.1667 6.66634V13.333C14.1667 13.793 13.7933 14.1663 13.3333 14.1663Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.41675 16.6667H11.2501"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9584 16.6667H16.6667C17.1267 16.6667 17.5001 16.2933 17.5001 15.8333V3.33333C17.5001 2.87333 17.1267 2.5 16.6667 2.5H11.2501C10.7901 2.5 10.4167 2.87333 10.4167 3.33333V5.15583"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33341 14.167V16.667"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default TechnologyIcon
